var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "price-list" },
    [
      _vm._l(_vm.feeList, function (part, index) {
        return _c(
          "div",
          { key: index, staticClass: "discount row-bg-yellow" },
          [
            _c("span", [
              _vm._v(
                _vm._s(part.name) +
                  " " +
                  _vm._s(
                    part.quantity && part.quantity >= 2
                      ? "x" + part.quantity
                      : ""
                  )
              ),
            ]),
            _c(
              "span",
              { staticClass: "bold", class: part.color ? part.color : "" },
              [_vm._v("NT$ " + _vm._s(part.price))]
            ),
          ]
        )
      }),
      _vm.detail && _vm.detail.finalPrice
        ? _c("div", { staticClass: "discount pb-5" }, [
            _c("div", [_vm._v("總付款金額")]),
            _c("div", { staticClass: "bold" }, [
              _vm._v("NT$ " + _vm._s(_vm.detail.finalPrice)),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }